import styled, { css } from "styled-components";
import { zIndex } from "@sonder/ui/source/styled/theme";

const sharedRowStyles = css`
  align-items: center;
  display: flex;
  min-height: 3.14rem;

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const BuildingWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.71rem;
  }
`;

export const SchedulerLayout = styled.div`
  display: grid;
  grid-template-columns: 9rem minmax(25rem, auto);
  grid-template-areas:
    "buildingRef buildingRef"
    "units rows";
  width: 100%;
`;

export const SchedulerBuildingRef = styled.div`
  ${sharedRowStyles}

  font-weight: bold;
  grid-area: buildingRef;
  position: sticky;
  top: 0.142rem;
  z-index: ${zIndex.schedulerHeader};
`;

export const SchedulerUnits = styled.div``;
export const SchedulerUnit = styled.div`
  grid-area: units;
  ${sharedRowStyles};
`;

export const SchedulerRow = styled.div`
  grid-area: rows;
  position: relative;
  ${sharedRowStyles};
`;
